
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator'

export const getModifierInfo = (modifier) => {
  const minSelects = modifier?.minSelects || '0';
  const maxSelects = modifier?.maxSelects || '0';
  const isMandatory = modifier?.isMandatory || false;
  const min = parseInt(minSelects, 10);
  const max = parseInt(maxSelects, 10);
  const isSingleOption = ((min === 0) && (max === 0) && isMandatory) || ((min === 0) && (max === 1));

  return {
    isSingleOption,
    max,
    min,
  }
}

@Component({
  components: {
  },
  model: {
    prop: 'modelValue',
    event: 'change',
  }
})
export default class OptionModifierGroup extends Vue {
  @Prop() options;
  @Prop() modifier;
  @Prop() modelValue: any;
  @InjectReactive() isMobile!: boolean;

  get modifierType() {
    const modifierProps = Object.getOwnPropertyNames(this.modifier);
    if (modifierProps.includes('productModifierOptions')) {
      return 'productModifierOptions';
    }
    if (modifierProps.includes('optionModifierChoices')) {
      return 'optionModifierChoices';
    }
    return '';
  }

  get info() {
    const { min, max, isSingleOption } = getModifierInfo(this.modifier);
    const isMandatory = this.modifier?.isMandatory || false;
    let remaining;

    const hasMax = !!max && this.modifier?.[this.modifierType]?.length !== max;
    if (!isSingleOption && Array.isArray(this.modelValue) && hasMax) {
      remaining = max - this.modelValue.length;
    }

    return {
      min,
      max,
      isSingleOption,
      hasMax,
      remaining,
      isMandatory,
    }
  }

  get value() {
    return this.modelValue;
  }

  set value(v) {
    if (!isNaN((parseInt(v, 10))) || Array.isArray(v)) {
      if (Array.isArray(v)) {
        v = v.map((v) => parseInt(v, 10));
      } else {
        v = parseInt(v, 10);
      }
      this.$emit('change', v);
    }
  }

  get computedOptions() {
    const useOptions: any[] = Array.isArray(this.options)
      ? this.options
      : this.options?.[this.modifierType]?.length
        ? this.options?.[this.modifierType]
        : [this.options];

    return useOptions.map(({ id, name, cost }) => ({ id: name.split(' ').join('-'), value: id, label: `${name}${cost ? ` +$${cost.toFixed(2)}` : ''}` }));
  }

  wrapperClasses(context, classes) {
    return classes.concat([
      'modifier-wrapper',
      `modifier-wrapper--${context.type}`
    ])
  }

  get type() {
    return !this.info.isSingleOption ? 'checkbox' : 'radio';
  }

  get message() {
    if ((this.info.max === this.computedOptions.length || (this.info.max === 0 && !this.info.isSingleOption))) {
      return 'Choose multiple options';
    } else if (!this.info.isSingleOption) {
      return this.info.remaining > 0 ? ` Choose up to ${this.info.remaining} more options` : 'No more choices remaining';
    }
    return 'Choose one option';
  }

  get validation() {
    const max = this.info.hasMax ? `|max:${this.info.max}` : '';
    const min = this.info.min ? `|min:${this.info.min}` : '';
    const required = this.info.min > 0 ? 'required' : '';
    if (required || min || max) {
      return `${required}${max}${min}`;
    }
    return null;
  }

  get validationName() {
    return `options for ${(this.modifier.description || this.modifier.name).replace(':', '')}`
  }
}
